export default {
  "content": "<path d=\"M0 20.539h22.105v3.46H0v-3.46zM11.065 0L0 4.497v3.208h22.13V4.497L11.066 0zM3.537 8.716h3.461v10.813h-3.46V8.716zM15.158 8.716h3.461v10.813h-3.46V8.716zM9.348 8.716h3.46v10.813h-3.46V8.716z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "23",
    "height": "24",
    "viewBox": "0 0 23 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};